<template>
    <div class="tabcontent">
        <v-container :fluid="true" v-resize="onResize" ref="planpostuplencontainer">
            <v-row align="center">
                <v-col cols="12" md="2" sm="4">
                    <v-btn color="primary" @click="addPlanPostuplen">Добавить</v-btn>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                    <v-skeleton-loader
                            :loading="loading"
                            type="list-item"
                            class="mx-auto"
                    >
                        <v-select
                                v-model="IdOrg"
                                :items="orglist"
                                label="Организация"
                                @input="changeOrg"
                        ></v-select>
                    </v-skeleton-loader>
                </v-col>
            </v-row>
        </v-container>
        <v-skeleton-loader
                :loading="loading"
                type="table-tbody"
                class="mx-auto"
        >
            <v-card v-show="loading === false">
                <v-simple-table class="table-cursor">
                    <template>
                        <thead>
                        <tr>
                            <th>№</th>
                            <th>Дата</th>
                            <th>Контрагент</th>
                            <th>Получатель</th>
                            <th>Сумма</th>
                            <th>Статус</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in planpostlist" :key="item.ID" @click="editCLick(item.ID)">
                            <td>{{ item.ID }}</td>
                            <td>{{ item.PlanDate | toDate }}</td>
                            <td>{{ item.NameSender }}</td>
                            <td>{{ item.NameReceiver }}</td>
                            <td class="text-right">{{ item.Summa | toCurrency}}</td>
                            <td>{{ statelist[item.StateOp] }}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-skeleton-loader>
    </div>
</template>

<script>

    import { bus } from '../../plugins/bus.js'

    export default {
        name: "PlanPostuplen",
        mounted() {
            this.$store.dispatch('GET_ORGFILTERS', {IdOrg: this.IdOrg, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1}).then(() => {
                this.$store.dispatch('GET_PLANPOSTUPLEN', {IdOrg: this.IdOrg, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1}).then(() => {
                    this.loading = false;
                });
            });

            bus.$on('refreshTabPlanPostuplen', this.refreshHandler);
            bus.$on('resetFilterhPlanPostuplen', this.resetfilterHandler);
        },
        beforeMount () {
            this.loadFilters();
        },
        data () {
            return {
                IdOrg: localStorage.getItem('idtsg'),
                IdHouse: '',
                errorMsg: '',
                loading: true,
                heightTable: (window.innerHeight - 200),
                statelist: ['Ожидает', 'Поступило']
            }
        },
        computed: {
            planpostlist() {
                return this.$store.getters.PLANPOSTUPLEN ? this.$store.getters.PLANPOSTUPLEN.data : [];
            },

            orglist() {
                let orglist = this.$store.getters.ORGFILTERS ? this.$store.getters.ORGFILTERS.orglist : null;
                let ret = [];
                if (orglist) {
                  if(localStorage.getItem('idtsg')>0){
                    this.$store.getters.ORGFILTERS.orglist.forEach((item) => {
                      if(item.ID == localStorage.getItem('idtsg'))
                        ret.push({value: item.ID, text: item.Name});
                    });
                  }else{
                    this.$store.getters.ORGFILTERS.orglist.forEach((item) => {
                      ret.push({value: item.ID, text: item.Name});
                    });
                  }

                }
                return ret;
            },
        },
        methods: {
            loadFilters: function() {
                let org = localStorage.getItem('VUE_TABS_PLANPOSTUPLEN_ORG');
                if (org) {
                    this.IdOrg = JSON.parse(org);
                }
            },
            saveFilters: function() {
                localStorage.setItem('VUE_TABS_PLANPOSTUPLEN_ORG', JSON.stringify(this.IdOrg));
            },
            addPlanPostuplen() {
              this.$parent.addTab('Добавить планируемое поступление', 0, 'PlanPostAdd', {id: 0, IdOrgDef: this.IdOrg});
            },
            editCLick(id) {
              this.$parent.addTab('Планируемое поступление '+id, id, 'PlanPostAdd', {id: id, IdOrgDef: this.IdOrg});
            },
            changeOrg() {
                this.refreshHandler();
                this.saveFilters();
            },
            refreshHandler() {
                this.$store.dispatch('GET_PLANPOSTUPLEN', {IdOrg: this.IdOrg, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1})
            },
            resetfilterHandler(params) {
              this.IdOrg = params.IdOrg;
              this.IdHouse = -1;
              this.refreshHandler();
            },
            onResize() {
                //this.heightTable = (window.innerHeight - this.$refs.planpostuplencontainer.clientHeight - 125);
                //console.log(window.innerHeight+" - "+this.$refs.planpostuplencontainer.clientHeight+" - 125");
            }
        },
        filters: {
            toCurrency: function (value) {
                let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
                return formatter.format(value/1);
            },
            toDate: function (value) {
                if (!value) return '';
                const [year, month, day] = value.split('-');
                return `${day}.${month}.${year}`;
            }
        }
    }
</script>

<style scoped>
    .tabcontent {
        padding-top: 35px;
    }
    .table-cursor tbody tr:hover {
      cursor: pointer;
    }
</style>